import { create } from "../../../common/utils/zustand_state_manager";
import { useControleEstoqueServices } from "./use_services";
import { IEstoqueRepository } from "../../../features/controleEstoque/domain/repositories/estoque_repository";
import { EstoqueRepository } from "../../../features/controleEstoque/data/repositories/estoque_repository";


type State = {
  controleEstoqueRepository: IEstoqueRepository,
};

export const usecontroleEstoqueRepositories = create<State>((set, get) => {
  const { controleEstoqueService } = useControleEstoqueServices.getState();
  return ({
    controleEstoqueRepository: new EstoqueRepository(controleEstoqueService),
  });
});